<template>
    <div class="registry-wrapper">
        <div class="columns">
            <div
                class="column"
                :class="[
                    permissaoVincular && permissaoCadastrar
                        ? 'is-4'
                        : permissaoVincular || permissaoCadastrar
                        ? 'is-6'
                        : 'is-8',
                ]"
            >
                <search-bar
                    :onSearch="debouncedOnSearch"
                    tooltipLabel="msg-busca-agro-ass-cultura-fase-fenologica"
                />
            </div>

            <div
                class="column situacao-select"
                :class="[
                    permissaoVincular && permissaoCadastrar
                        ? 'is-2'
                        : permissaoVincular || permissaoCadastrar
                        ? 'is-3'
                        : 'is-4',
                ]"
            >
                <vss-select
                    ref="situacaoInput"
                    title="situacao"
                    :options="situacoes"
                    :mlLabels="true"
                    @input="onSituacaoChanged"
                    v-model="situacao"
                    :height="40"
                    :clearable="true"
                />
            </div>

            <!-- BOTÃO DE VÍNCULO -->
            <div class="column is-3" v-if="permissaoVincular">
                <button class="save-btn botao-acao" type="button" @click="showModal = !showModal">
                    {{ $t('vincular-fasefenologica') }}
                </button>
            </div>
            <!-- Botao abre um modal para cadastro de fase fenologica -->
            <div class="column is-3" v-if="permissaoCadastrar">
                <button class="save-btn botao-acao" type="button" @click="showModalCadastro">
                    {{ $t('novo-fasefenologica') }}
                </button>
            </div>
        </div>
        <!-- LISTAGEM -->
        <div class="registry-wrapper">
            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assCulturaFaseFenologicaList"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-if="props.row[f.key] == 1"
                                type="is-success"
                                size="is-medium"
                                >{{ $t('ativo') }}</b-tag
                            >
                            <b-tag
                                class="table-tag table-tag-full-width"
                                v-else
                                type="is-danger"
                                size="is-medium"
                                >{{ $t('inativo') }}</b-tag
                            >
                        </div>
                        <div v-else-if="f.key == 'excluir'">
                            <span v-if="permissaoUpdateSituacao">
                                <b-button
                                    class="action-button"
                                    :type="props.row['situacao'] == 1 ? 'is-danger' : 'is-success'"
                                    :icon-right="props.row['situacao'] == 1 ? 'delete' : 'check'"
                                    @click="promptChangeSituacao(props.row)"
                                    v-tippy
                                    :title="
                                        $t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')
                                    "
                                />
                            </span>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModal" @fecharModal="fecharModal">
                <div class="bg">
                    <FaseFenologicaModal
                        :idtipocultura="$route.params.id"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
            <!-- MODAL DE CADASTRO  -->
            <b-modal :active.sync="modalCadastro">
                <div>
                    <FaseFenologicaCadastroModal
                        @fecharModal="fecharModal"
                        :idtipocultura="$route.params.id"
                        @cadastrado="cadastrado"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
import FaseFenologicaService from '@/services/agro/FaseFenologicaService';
// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';
import FaseFenologicaModal from '@/components/agro/cultura/modal/FaseFenologicaModal.vue';
import FaseFenologicaCadastroModal from '@/components/agro/cultura/modal/FaseFenologicaCadastroModal.vue';

export default {
    components: {
        ContainerLoader,
        FaseFenologicaModal,
        FaseFenologicaCadastroModal,
    },
    data() {
        return {
            assCulturaFaseFenologicaIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'AGRO_ASSCULTURAFASEFENOLOGICA'
            ),
            faseFenologicaIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'AGRO_FASEFENOLOGICA'
            ),
            service: new FaseFenologicaService(this.$http, this.$router),
            assCulturaFaseFenologicaList: [],
            situacoes: [
                { id: 2, label: 'todos' },
                { id: 1, label: 'ativos' },
                { id: 0, label: 'inativos' },
            ],
            situacao: { id: 2, label: 'todos' },
            fields: [
                { key: 'codigo', width: '10%', sortable: true, sortFn: null },
                { key: 'descricao', width: null, sortable: true, sortFn: null },
                { key: 'situacao', width: 70, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: true, sortFn: null },
            ],
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            delete: null,
            queryFilter: '',
            column: 'descricao',
            order: 'asc',
            permissao: false,
            showModal: false,
            modalCadastro: false,

            //permissoes relativas à exibição dos botões
            permissaoVincular: false,
            permissaoUpdateSituacao: false,
            permissaoCadastrar: false,
            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        setTimeout(() => {
            this.$emit('isChanged', false);
        }, 500);

        if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissaoFaseFenologica = this.hasPermissionAccess(
                'agro',
                'agro-cadastros',
                'agro-fasefenologica'
            );
            this.permissao = this.hasPermissionAccess('agro', 'agro-cadastros', 'agro-cultura');
        } else if (this.isVenda) {
            this.permissaoFaseFenologica = this.hasPermissionAccess(
                'vendas',
                'crm',
                'ven-fasefenologica'
            );
            this.permissao = this.hasPermissionAccess('vendas', 'crm', 'ven-cultura');
        }
        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: `${this.abrev}-cultura` },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }

        this.permissaoVincular = this.permissao.create && !this.assCulturaFaseFenologicaIntegracao;
        this.permissaoUpdateSituacao =
            this.permissao.update && !this.assCulturaFaseFenologicaIntegracao;
        this.permissaoCadastrar =
            this.permissaoFaseFenologica.create && !this.faseFenologicaIntegracao;
    },
    methods: {
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        onSituacaoChanged(val) {
            this.situacao = val
                ? this.situacoes.filter((v) => v.id == val.id)[0]
                : this.situacoes[0];
            this.carregarDados();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        generateId(numberId) {
            return this.$route.name + '-tabela-' + numberId;
        },
        carregarDados(currentPage = 1) {
            this.cleanHide = true;
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.$route.params.id,
                    this.abrev,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.assCulturaFaseFenologicaList = value;
                    this.isEmpty = this.assCulturaFaseFenologicaList.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os acertos.');
                })
                .finally((_) => {
                    this.cleanHide = false;
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    id: m.idagroassculturafasefenologica,
                    codigo: m.agroFaseFenologica.idagrofasefenologicaerp,
                    descricao: m.agroFaseFenologica.descricao,
                    situacao: m.situacao,
                    excluir: 'excluir',
                };
            });
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row.descricao }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.situacao == 1
                    ? 'msg-erro-ao-reativar-associacao-fasefenolgica'
                    : 'msg-erro-ao-desativar-associacao-fasefenolgica';

            let tempAssCulturaFaseFenologica = {
                idagroassculturafasefenologica: this.delete.id,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };
            this.isLoading = true;

            this.service
                .updateSituacao(tempAssCulturaFaseFenologica, this.abrev)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.situacao == 1
                                ? 'msg-sucesso-ao-reativar-associacao-fasefenolgica'
                                : 'msg-sucesso-ao-desativar-associacao-fasefenolgica';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        showModalCadastro() {
            this.modalCadastro = !this.modalCadastro;
        },
        fecharModal() {
            this.modalCadastro = false;
            this.modalManage = false;
            this.showModal = false;
            this.carregarDados();
        },

        cadastrado() {
            this.carregarDados();
            this.modalCadastro = false;
            this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
        },
    },
};
</script>
<style lang="scss" scoped>
.situacao-select {
    div {
        height: 40px;
    }
}

.botao-acao {
    margin-top: 24px;
    width: 100%;
    height: 40px;
}

@media (max-width: 760px) {
    .search-bar {
        padding-bottom: 0.4rem;
    }

    .situacao-select {
        width: 100%;
        padding-bottom: 0.8rem;
    }

    .botao-acao {
        margin-top: 0;
    }
}
</style>
